import { propelyApi } from "@libs/firebase/api";
import { IApiTaskType, TApiTaskType } from "@propely/propely-typings";
import { useQuery } from "react-query";
import { z } from "zod";
import { TApiGetTaskTypesResponse } from "./taskTypes.schema";

export const TApiTaskTypeArray = z.array(TApiTaskType);

export const useTaskTypeById = ({ taskTypeId }: { taskTypeId: string | undefined }) => {
  const $taskTypes = useQuery(useTaskTypesKey({}), () =>
    propelyApi()
      .get("/taskTypes")
      .then((response) => {
        return TApiTaskTypeArray.parse(response.data.datas);
      })
  );

  const taskType = $taskTypes.data?.find((taskType) => taskType.id === taskTypeId);

  return {
    $taskTypes,
    taskType,
  };
};

type TaskTypeQueryParams = {
  companyID?: string;
  propertyID?: string;
};

export const useTaskTypesKey = (params: TaskTypeQueryParams) => {
  return [
    "get-task-types",
    {
      companyID: params.companyID,
      propertyID: params.propertyID,
    },
  ];
};

export const useTaskTypes = ({ companyID, propertyID, enabled }: { companyID?: string; propertyID?: string; enabled?: boolean } = {}) => {
  const params = new URLSearchParams();
  if (companyID) params.append("companyID", companyID);
  if (propertyID) params.append("propertyID", propertyID);

  const $taskTypes = useQuery(
    useTaskTypesKey({ companyID, propertyID }),
    () =>
      propelyApi()
        .get(`/taskTypes?${params.toString()}`)
        .then((response) => {
          return TApiTaskTypeArray.parse(response.data.datas);
        }),
    {
      enabled: enabled,
      cacheTime: 1000 * 60 * 5, // 5 minutes before data gets garbage collected
    }
  );

  const taskTypes = $taskTypes.data;
  return { $taskTypes, taskTypes };
};

export class StaticIApiTaskTypes {
  static all: IApiTaskType[] = [];
}
export const loadAllTaskTypes = async (): Promise<IApiTaskType[]> => {
  const response = await propelyApi().get(`/taskTypes`);
  const datas = TApiGetTaskTypesResponse.parse(response.data).datas;
  StaticIApiTaskTypes.all = datas;
  return datas;
};
